import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducer, FEATURE_KEY } from './reducers';
import { NGXCoreEffects } from './effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(FEATURE_KEY, reducer),
    EffectsModule.forFeature([NGXCoreEffects]),
  ],
  exports: [],
  declarations: [],
  providers: [],
})
export class NgxModuleCoreModule {}
